var map = {
	"./245-Spliceosomes-3jb9.jpg": "28ac",
	"./cake.png": "41e2",
	"./donut.png": "23f7",
	"./logo.png": "9d64",
	"./vue-crud-avatar.png": "d2ae",
	"./vue-crud-lg.png": "075e",
	"./vue-crud-md.png": "e183",
	"./vue-crud-sm.png": "afbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";